import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom-latest';
import { useFlags } from 'launchdarkly-react-client-sdk';
import HeaderTabs from 'common/HeaderTabs_updated';
import { withStorageData } from 'utilities/withStorageData';
import Security from 'ui/Admin/Security';
import AiFirmSetting from 'ui/Admin/AiFirmSetting';
import AddEditTags from './AddEditTags';
import TextLogs from './TextLogs';

const Preferences = () => {
  const navigate = useNavigate();
  const { enableAi } = useFlags();

  // Build main tabs array
  const PreferencesTabs = useMemo(() => [
    ...(enableAi ? [{
      label: 'Settings',
      value: 'settings',
      tab: <AiFirmSetting />
    }] : []),
    {
      label: 'Security',
      value: 'security',
      tab: <Security />
    },
    {
      label: 'Tags',
      value: 'tags',
      tab: <AddEditTags/>
    },
    {
      label: 'Text Logs',
      value: 'textLogs',
      tab: <TextLogs/>
    },
  ], [enableAi]);

  // Initialize state with active tab - default to Settings tab
  const parsedUrl = new URL(window.location.href);
  const tab = parsedUrl.searchParams.get('tab');
  let tabIndex = 0;
  if (tab) {
    tabIndex = PreferencesTabs.findIndex((each) => each.value === tab);
  }
  const [activeTab, setActiveTab] = useState(tabIndex === -1 ? 0 : tabIndex);

  useEffect(() => {
    document.title = 'Preferences';
    if (activeTab !== undefined && PreferencesTabs[activeTab]) {
      navigate(
        `/preferences?tab=${PreferencesTabs[activeTab].value}`,
      );
    }
  }, [activeTab, navigate, PreferencesTabs]);

  const changeActiveTab = (key) => {
    setActiveTab(key);
    navigate(`/preferences?tab=${PreferencesTabs[key].value}`);
  };

  return (
    <div id="content">
      <header className="pb-0 pt-0">
        <HeaderTabs
          data={PreferencesTabs}
          activeTab={activeTab}
          handleClick={changeActiveTab}
        />
      </header>
      <div>{PreferencesTabs[activeTab].tab}</div>
    </div>
  );
};

export default withStorageData(Preferences);
